import React, { ReactNode } from 'react'
import Skeleton from 'react-loading-skeleton'
import { SKELETON_BASE_COLOR, SKELETON_HIGHLIGHT_COLOR } from '../../constants'
import { formatCurrency, formatNumber } from '../../helpers'
import Icon from '../icon'

interface CountCardProps {
  count?: number
  valueSuffix?: string
  text: string
  icon?: string
  isCurrency: boolean
  loading?: boolean
  children?: ReactNode
}

const CountCard: React.FC<CountCardProps> = ({
  count,
  valueSuffix,
  text,
  icon,
  isCurrency,
  loading = false,
  children,
}) => {
  return loading ? (
    <div
      className={`bg-transparent
      p-6 rounded-2xl
      border border-divider-gray
      flex flex-col gap-2 shadow-count-card
      `}
    >
      <Skeleton
        width={'20%'}
        height={26}
        baseColor={SKELETON_BASE_COLOR}
        highlightColor={SKELETON_HIGHLIGHT_COLOR}
        className="!rounded-2xl"
      />

      <Skeleton
        width={'100%'}
        height={34}
        baseColor={SKELETON_BASE_COLOR}
        highlightColor={SKELETON_HIGHLIGHT_COLOR}
        className="!rounded-2xl"
      />

      <Skeleton
        width={'50%'}
        height={22}
        baseColor={SKELETON_BASE_COLOR}
        highlightColor={SKELETON_HIGHLIGHT_COLOR}
        className="!rounded-2xl"
      />
    </div>
  ) : (
    <div
      className={`bg-transparent
      p-6 rounded-2xl
      border border-divider-gray
      flex flex-col shadow-count-card relative
      `}
    >
      <div className="flex items-start justify-between flex-1 ">
        <div className="flex flex-col gap-2 h-full justify-between">
          <p className="text-base text-sec-black">{text}</p>
          <p className="text-2xl font-bold">
            {isCurrency ? formatCurrency(count ?? 0) : formatNumber(count ?? 0)}{' '}
            {valueSuffix}
          </p>
        </div>

        {icon !== undefined && (
          <div className="text-gray-200">
            <Icon id={icon} height={35} width={35} />
          </div>
        )}
      </div>

      {children ? (
        <div className="absolute  bottom-1 text-sm text-gray-500">
          {' '}
          {children}
        </div>
      ) : undefined}
    </div>
  )
}

export default CountCard
